import { Box, TextField, Typography } from '@mui/material';
import React, { memo } from 'react';
import { useStackModalContext } from '../context/StackModalContext';
import ControlModeList from './ControlModeList';

/**
 * Component for rendering the form content of the stack modal
 */
const StackModalForm: React.FC = () => {
  const context = useStackModalContext();

  if (!context) {
    throw new Error('StackModalForm must be used within a StackModalProvider');
  }

  const {
    state: { stackName, nameError },
    actions: {
      form: { handleNameChange },
    },
  } = context;

  return (
    <>
      <Box sx={{ mb: 3 }}>
        <TextField
          label='Stack Name'
          value={stackName}
          onChange={handleNameChange}
          fullWidth
          required
          error={!!nameError}
          helperText={nameError}
        />
      </Box>

      <Typography
        variant='h6'
        sx={{
          mb: 3,
          mt: 3,
          fontWeight: 'bold',
          borderBottom: (color) => `1px solid ${color.palette.divider}`,
          pb: 1,
        }}
      >
        Control Modes
      </Typography>

      <ControlModeList />
    </>
  );
};

export default memo(StackModalForm);
